type RewriteAfterRendererProps = {
  result: string
}

export function RewriteAfterRenderer({ result }: RewriteAfterRendererProps) {
  return (
    <div>
      <div className='mb-1 text-xs font-medium uppercase tracking-wide text-muted-foreground'>
        After
      </div>
      <pre className='max-h-48 overflow-y-auto rounded-md border border-input bg-muted/50 p-3 text-sm font-mono text-foreground whitespace-pre-wrap'>
        {result || '—'}
      </pre>
    </div>
  )
}
